<template>
    <div>
        <rkm-modal
            extra-large
            ref="RkmModal"
            title="Notificações"
        >
            <rkm-table
                :fields="fields"
                :items="items"
                sort-by="dataHoraAtualizacao"
                :sort-desc="true"
                :sort-compare="sortCompare"
                @sort-changed="handleSortChange"
            >
                <template v-slot:cell(actions)="{item}">
                    <rkm-button
                        @click="$refs.ModalMensagem.open(item)"
                        color="primary"
                        small
                        title="Mensagem"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>

            <template v-slot:footer="{cancel}">
                <rkm-button
                    :disabled="!!loading"
                    @click="cancel"
                    color="secondary"
                >
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalMensagem ref="ModalMensagem" />
    </div>
</template>

<script>
// Components.
import ModalMensagem from './components/mensagem/Modal'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {ModalMensagem},
    computed: {
        ...mapGetters({
            loading: 'getLoading',
            lotacao: 'getLotacao',
        }),
    },
    created() {
        this.repositories = {
            notificacao: this.getConectaSusRepository('administracao.notificacao'),
        }
        if (!this.model) {
            this.model = {
                sortBy: 'dataHoraAtualizacao',
                sortDesc: true
            };
        } else {
            this.model.sortBy = this.sortBy || 'dataHoraAtualizacao';
            this.model.sortDesc = this.sortDesc !== undefined ? this.sortDesc : true;
        }
    },
    data: () => ({
        fields: [
            {key: 'dataHoraAtualizacao',
                label: 'Data/Hora',
                searchable: true,
                sortable: true,
                sortDirection: 'desc' 
            },
            {key: 'tipoNome', label: 'Tipo', sortable: true},
            {key: 'titulo', label: 'Título', sortable: true},
            {filterByFormatted: true, formatter: (value) => value ? 'Sim' : 'Não' , key: 'visualizado', label: 'Visualizada', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        items: [],
        order: {
            by: 'dataHoraAtualizacao',
            dir: 'desc'
        },
        model: {
            sortBy: 'dataHoraAtualizacao',
            sortDesc: true
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            const request = {
                lotacaoId: this.lotacao.id,
                order: this.order
            }

            this.setLoading()

            this.repositories.notificacao.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSortChange(ctx) {
            if (ctx) {
                this.order.by = ctx.sortby
                this.order.dir = ctx.sortDesc ? 'desc' : 'asc'
            }
            this.load()
        },
        sortCompare(a, b, key) {
            if (key === 'dataHoraAtualizacao') {
                return new Date(a[key]) - new Date(b[key]);
            }
            return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
        }
    },
    mixins: [error, repository, stringCase],
}
</script>